; (function ($) {

	const Resources = {

		init() {
			$(document).ready(() => {
				this.bindSearchForm();
				this.reloadWhenKeywordRemoved();
				this.bindDownloadTracking();
			});
		},

		bindDownloadTracking() {
			document.querySelectorAll('.single-resource__download').forEach((downloadLink) => {
				downloadLink.addEventListener('click', () => {
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						event: 'resource_download',
						resource_id: Number(downloadLink.dataset.resourceId),
						resource_title: downloadLink.dataset.resourceTitle,
						is_embedded: downloadLink.dataset.isEmbedded === 'true',
						course_id: downloadLink.dataset.courseId ? Number(downloadLink.dataset.courseId) : null,
					});
				});
			});
		},

		stripPagination(url) {
			url.pathname = url.pathname.replace(/\/page\/\d+\/?/, '/');
			url.searchParams.delete('paged');
			url.searchParams.delete('page');
			return url;
		},

		getCheckboxFilterParams() {
			const form = document.querySelector('.directory-results__sidebar-filters');
			if (!form) {
				return new FormData();
			}
			return new FormData(form);
		},

		clearCheckboxFilterParams(url) {
			const checkboxNames = [...new Set(
				[...document.querySelectorAll('.directory-results__sidebar-filters input[type="checkbox"]')]
					.map(cb => cb.name.replace(/\[.*\]$/, ''))
			)];

			[...url.searchParams.keys()].forEach(key => {
				const baseName = key.replace(/\[.*\]$/, '');
				if (checkboxNames.includes(baseName)) {
					url.searchParams.delete(key);
				}
			});

			return url;
		},

		bindSearchForm() {
			const form = document.querySelector('.cis-resource-search');
			if (!form) {
				return;
			}

			form.addEventListener('submit', function (e) {
				e.preventDefault();

				const url = Resources.stripPagination(new URL(window.location.href));

				Resources.clearCheckboxFilterParams(url);

				Resources.getCheckboxFilterParams().forEach((value, key) => {
					url.searchParams.append(key, value);
				});

				const searchInput = form.querySelector('input[name="q"]');
				if (searchInput.value) {
					url.searchParams.set('q', searchInput.value);
				} else {
					url.searchParams.delete('q');
				}

				window.location.href = url.toString();
			});
		},
		reloadWhenKeywordRemoved() {
			const searchForm = document.querySelector('.cis-resource-search');
			const searchInput = document.getElementById('cis-search');
			if (!searchForm) {
				return;
			}
			if (!searchInput) {
				return;
			}

			let initialValue = searchInput.value;

			const submitSearchForm = function () {
				if (typeof searchForm.requestSubmit === 'function') {
					searchForm.requestSubmit();
					return;
				}

				searchForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
			};

			searchInput.addEventListener('focus', function () {
				initialValue = searchInput.value;
			});

			searchInput.addEventListener('blur', function () {
				if (searchInput.value !== initialValue && searchInput.value.trim() !== '') {
					submitSearchForm();
				}
			});
			
			searchInput.addEventListener('input', function () {
				if (searchInput.value.trim() === '') {
					submitSearchForm();
				}
			});
		}

	};

	if (document.querySelector('.cis-resource-search, .single-resource__download')) {
		Resources.init();
	}

}(jQuery));